import React from 'react';
import { Header, Segment } from 'semantic-ui-react';
import UsersTable from '../../components/UsersTable';

// 租户管理员只读用户列表，租户由服务端按绑定自动限定
const TenantAdminUsers = () => (
  <Segment>
    <Header as='h3'>本租户用户</Header>
    <UsersTable readOnly />
  </Segment>
);

export default TenantAdminUsers;
